import { GroundFragment } from '@amf/shared/types/graphql';
import Container from '@amf/shared/components/layout/Container';
import Map from '@amf/shared/components/utils/Map';
import Link from 'next/link';
import React from 'react';
import { useTranslate } from '@tolgee/react';
import Button from '@amf/shared/components/button/Button';
import IconArrowLeft from '@amf/shared/icons/IconArrowLeft';

interface Props {
  ground: GroundFragment;
  prefixes: { ground: string };
}

function GroundHeader({ ground, prefixes }: Props) {
  const { t } = useTranslate();
  return (
    <div className='GroundHeader'>
      <Container className='GroundHeader__container'>
        <div className='GroundHeader__top'>
          <h1 className='GroundHeader__title'>{ground.name}</h1>
          <Link href={prefixes.ground}>
            <a>
              <Button variant='white-outline' leftIcon={<IconArrowLeft />}>
                {t('ground.header.back')}
              </Button>
            </a>
          </Link>
        </div>
        <div className='GroundHeader__map'>
          <Map
            title={ground.name}
            lat={ground.latitude}
            lng={ground.longitude}
            zoom={15}
            width='100%'
            height='100%'
          />
          <div className='GroundHeader__cta'>
            <a
              href={`https://mapy.cz/zakladni?source=coor&id=${ground.latitude}%2C${ground.longitude}`}
              className='GroundHeader__button'
              target='_blank'
              rel='noreferrer'
            >
              <i className='bi bi-geo-fill' /> {ground.address}
            </a>
          </div>
        </div>
      </Container>
    </div>
  );
}

export default GroundHeader;
